/**
 * Shared address normalization for create forms and personnel profile.
 */

export function normalizeAddressValueForCreate(val) {
  if (!val) {
    return {
      address: "",
      addressRaw: "",
      line1: "",
      line2: "",
      city: "",
      province: "",
      postal_code: "",
      country: "",
    };
  }
  if (typeof val === "string") {
    return {
      address: val,
      addressRaw: val,
      line1: val,
      line2: "",
      city: "",
      province: "",
      postal_code: "",
      country: "",
    };
  }

  const street = String(val.street || "").trim();
  const line2 = String(val.address2 || val.line2 || "").trim();
  const city = String(val.city || "").trim();
  const region = String(val.region || val.province || "").trim();
  const zip = String(val.zip || val.postal_code || "").trim();
  const country = String(val.country || "").trim();

  const address = [line2, street, city, region, zip, country]
    .filter(Boolean)
    .join(", ");
  return {
    address,
    addressRaw: val,
    line1: street,
    line2,
    city,
    province: region,
    postal_code: zip,
    country,
  };
}

/** Build AddressAutocomplete value from saved profile/account fields. */
export function buildAddressAutocompleteValue(data) {
  if (!data) return "";
  if (data.addressRaw && typeof data.addressRaw === "object") {
    return data.addressRaw;
  }
  if (typeof data.addressRaw === "string" && data.addressRaw.trim()) {
    return data.addressRaw;
  }
  if (typeof data.address === "string" && data.address.trim()) {
    return data.address;
  }

  const line1 = String(data.line1 || data.street || "").trim();
  const line2 = String(data.line2 || data.address2 || "").trim();
  const city = String(data.city || "").trim();
  const province = String(data.province || data.region || "").trim();
  const postal = String(data.postal_code || data.zip || "").trim();
  const country = String(data.country || "").trim();

  if (!line1 && !city && !province && !postal && !country) {
    return "";
  }

  return {
    street: line1,
    address2: line2,
    city,
    region: province,
    zip: postal,
    country,
  };
}

/** Apply normalized address fields via a setField(key, value) callback. */
export function applyAddressToForm(setField, val) {
  const next = normalizeAddressValueForCreate(val);
  setField("addressRaw", next.addressRaw);
  setField("address", next.address);
  setField("line1", next.line1);
  setField("line2", next.line2);
  setField("city", next.city);
  setField("province", next.province);
  setField("postal_code", next.postal_code);
  setField("country", next.country);
}
